import axios from './../../config/axios'
function tree () {
    return axios().get('/auth/permissions')
}
export default {
    tree
}